// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i2iH","type":"styles_type__35R6G","choices":"styles_choices__5IwfP"};